import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import SurveyTechies from "@/pages/SurveyTechies";
import CadTechies from "@/pages/CadTechies";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLeads from "@/pages/AdminLeads";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import LocationsIndex from "@/pages/LocationsIndex";
import StatePage from "@/pages/StatePage";
import CountyPage from "@/pages/CountyPage";
import MetroPage from "@/pages/MetroPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import DisciplinesIndex from "@/pages/DisciplinesIndex";
import DisciplinePage from "@/pages/DisciplinePage";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/services/:slug/case-studies/:caseSlug" element={<CaseStudyDetail />} />
              <Route path="/services/:slug/:subSlug" element={<ServiceDetail />} />
              <Route path="/survey-techies" element={<SurveyTechies />} />
              <Route path="/cad-techies" element={<CadTechies />} />
              <Route path="/cad-services" element={<LocationsIndex />} />
              <Route path="/cad-services/:stateSlug" element={<StatePage />} />
              <Route path="/cad-services/:stateSlug/:countySlug" element={<CountyPage />} />
              <Route path="/metros/:metroSlug" element={<MetroPage />} />
              <Route path="/disciplines" element={<DisciplinesIndex />} />
              <Route path="/disciplines/:slug" element={<DisciplinePage />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/leads" element={<AdminLeads />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
